import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=0b465c9e&scoped=true"
import script from "./ResultDetail.vue?vue&type=script&lang=js"
export * from "./ResultDetail.vue?vue&type=script&lang=js"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&id=0b465c9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b465c9e",
  null
  
)

export default component.exports